define('modules/content_recommendations/content_recommendations_filter_view',[
  'backbone',
  'jquery',
  '_',

  'modules/modal/modal_view',

  'text!./content_recommendations_filter_template.html',
  './content_recommendations_filter_model',
  'modules/content_recommendations/modal/auto_publish_modal',
  'modules/content_recommendations/modal/auto_publish_settings_modal',
  'modules/content_recommendations/modal/auto_publish_settings_model',
], function (
  Backbone,
  $,
  _,
  ModalView,
  ContentRecommendationsFilterTemplate,
  ContentRecommendationsFilterModel,
  AutoPublishModal,
  AutoPublishSettingsModal,
  AutoPublishSettingsModel
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];
      this.render();

      this.setupFilters();
      this.filterModel = new ContentRecommendationsFilterModel();
      this.listenTo(
        this.filterModel,
        'sync',
        function (model) {
          var i;

          if (this.zoneFilterControl) {
            var modelZoneOptions = model.get('zoneOptions');
            if (modelZoneOptions) {
              modelZoneOptions = modelZoneOptions.options;
            }

            for (i = 0; i < modelZoneOptions.length; i++) {
              this.zoneFilterControl[0].selectize.addOption(
                modelZoneOptions[i]
              );
            }
          }
          return {};
        },
        this
      );

      this.autoPublishSettingsModel = new AutoPublishSettingsModel({}, { campaignType: this.filterModel.get('campaignType') || 'tacticaloffer' });
      this.listenTo(this.autoPublishSettingsModel, 'sync', function (model) {
        this.isAutoPublish = this.autoPublishSettingsModel.get('isActive');
        this.setAutoPublishButton();
      });
      this.autoPublishSettingsModel.fetch();

      this.listenTo(this.filterModel, 'change:campaignType', function (event) {
        if (this.filterModel.get('campaignType') !== 'additional_marketing') {
          this.autoPublishSettingsModel.set('campaignType', this.filterModel.get('campaignType'));
          this.autoPublishSettingsModel.fetch();
        }
        else {
          document.getElementById('auto-publish').style.display = 'none';
        }
      }, this);
      

      this.filterModel.fetch();

      Backbone.on('autopublish', this.autoPublish, this);
    },

    filterModel: null,
    hasSidebar: false,

    zoneFilterControl: null,

    template: _.template(ContentRecommendationsFilterTemplate),

    events: {
      'keyup input#search-field': 'onSearchTextChanged',
      'click .js-auto-publish': 'openAutoPublishingModal',
      'click .js-auto-publish-settings': 'openAutoPublishSettingsModal',
    },

    onSearchTextChanged: _.debounce(function () {
      this.triggerFilterOptionChange();
    }, 500),

    openAutoPublishingModal: function (e) {
      e.preventDefault();
      var modalView = new ModalView({
        title: this.isAutoPublish
          ? _.t('content_recommendations.auto_publish_modal.deactivate.title')
          : _.t('content_recommendations.auto_publish_modal.activate.title'),
        modalContent: new AutoPublishModal({
          isAutoPublish: this.isAutoPublish,
        }),
        bottom_toolbar: false,
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openAutoPublishSettingsModal: function (e) {
      e.preventDefault();
      var modalView = new ModalView({
        title: _.t('content_recommendations.auto_publish_settings_modal.title'),
        modalContent: new AutoPublishSettingsModal({
          isAutoPublish: this.isAutoPublish,
          campaignType: this.filterModel.get('campaignType'),
        }),
        bottom_toolbar: false,
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    autoPublish: function () {
      this.isAutoPublish = !this.isAutoPublish;
      this.autoPublishSettingsModel.set({ 'filterType': '0' });
      this.autoPublishSettingsModel.set('isActive', this.isAutoPublish);
      this.autoPublishSettingsModel.set( 'campaignType', this.filterModel.get('campaignType'));
      this.autoPublishSettingsModel.save(null, { type: 'PUT' });
      this.setAutoPublishButton();
    },

    setAutoPublishButton: function () {
      var text = this.isAutoPublish
        ? _.t('content_recommendations.button.deactivate_auto_publish')
        : _.t('content_recommendations.button.activate_auto_publish');
      document.getElementById('button-auto-publish').textContent = text;
      document.getElementById('auto-publish').style.display = '';

      if (this.isAutoPublish) {
        this.$('.js-auto-publish-settings').attr('disabled', false);
      } else {
        this.$('.js-auto-publish-settings').attr('disabled', true);
      }
    },

    setupFilters: function () {
      var that = this;
      this.zoneFilterControl = this.$('#active_zones').selectize({
        plugins: ['remove_button'],
        create: false,
        onChange: function (value) {
          that.triggerFilterOptionChange();
        },
      });
      return this;
    },

    triggerFilterOptionChange: function () {
      var zoneOptions = this.filterModel.get('zoneOptions');
      zoneOptions.active = this.zoneFilterControl[0].selectize.items;
      this.filterModel.set('zoneOptions', zoneOptions);
      var searchText = $('input#search-field')[0].value;
      this.filterModel.set('searchText', searchText);
      this.filterModel.trigger('change', this.filterModel);
    },

    render: function () {
      this.$el.html(this.template({ isAutoPublish: this.isAutoPublish }));
      return this;
    },

    remove: function () {
      Backbone.off('autopublish');
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

